import { render, staticRenderFns } from "./CatalogOrderScreen.vue?vue&type=template&id=9781be16&scoped=true"
import script from "./CatalogOrderScreen.vue?vue&type=script&lang=js"
export * from "./CatalogOrderScreen.vue?vue&type=script&lang=js"
import style0 from "./CatalogOrderScreen.vue?vue&type=style&index=0&id=9781be16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9781be16",
  null
  
)

export default component.exports